import { Step } from 'pages/AutomationEngine/types/automation';
import { useAutomationsSelector } from '__pages/AutomationEngine/store/react';

export const useIsVariableDropZone = (step: Step) => {
  const placingVariable = useAutomationsSelector(
    (state: any) => state.placingVariable
  );

  const enabledVariableDropzones = useAutomationsSelector(
    (state: any) => state.enabledVariableDropzones
  );

  return Boolean(placingVariable && enabledVariableDropzones[step.id]);
};
